import React from 'react';
import {connect} from 'react-redux';
import Text from '../containers/Text';
import SVG from 'react-inlinesvg';
import queryString from 'query-string';
import facebookIcon from '../images/facebook.svg';
import twitterIcon from '../images/twitter.svg';
import whatsappIcon from '../images/whatsapp.svg';
import printIcon from '../images/print.svg';

class SocialButtons extends React.Component {
  buildLink() {
    // url consists of:
    //  location.origin + location.pathname +
    // + current setting
    // + city
    // + parcelShopNumber
    const link = document.createElement('a');
    const currentSearch = queryString.parse(location.search);

    link.href = location.href;
    link.search = queryString.stringify(Object.assign({}, currentSearch, {
      city: this.props.search.address,
      shopid: this.props.parcelShopNumber
    }));

    return link.href;
  }

  render() {
    const targetLink = this.buildLink();
    const uriTargetLink = encodeURIComponent(targetLink);

    const sharingShopInfo = {
      message: encodeURIComponent('... empfiehlt für den Paketversand und -empfang den: Hermes Paketshop, '),
      shopData: encodeURIComponent(`
        ${this.props.shopName}, ${this.props.shopOwner}, ${this.props.shopAddress.street} ${this.props.shopAddress.houseNumber},
        ${this.props.shopAddress.zip} ${this.props.shopAddress.city}`)
    };

    return (
      <ul className='social-buttons' ref={list => this.list = list}>
        <li className="btn btn-social facebook">
          <a href={`https://www.facebook.com/sharer/sharer.php?u=${uriTargetLink}&quote=${sharingShopInfo.message} ${sharingShopInfo.shopData}`} target='_blank'>
            <SVG src={facebookIcon} />{' '}
            <Text id='social-buttons.facebook' />
          </a>
        </li>

        <li className="btn btn-social whatsapp">
          <a href={`whatsapp://send?text=Hermes PaketShop: ${uriTargetLink}`} data-action="share/whatsapp/share">
            <SVG src={whatsappIcon} />{' '}
            <Text id='social-buttons.whatsapp' />
          </a>
        </li>

        <li className="btn btn-social print">
          <a onClick={() => print()} href='#'>
            <SVG src={printIcon} />{' '}
            <Text id='social-buttons.print' />
          </a>
        </li>

      </ul>
    );
  }
}

const mapStateToProps = ({search}) => ({
  search
});

export default connect(mapStateToProps)(SocialButtons);
